import React from 'react';
import { Link } from 'react-router-dom';

import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';

const LOGO_SRC = `${process.env.PUBLIC_URL || ''}/images/logo/${encodeURIComponent('logo white.png')}`;

export default function Footer(): React.ReactElement {
  return (
    <footer className="bg-sky-800 text-white">
      <div className="mx-auto w-full max-w-7xl px-4 pt-16 pb-12 sm:px-6 sm:pt-12 lg:px-12 lg:py-16">
        <div className="grid gap-8 lg:grid-cols-6">
          {/* Company Info */}
          <div className="lg:col-span-2 text-center sm:text-left">
            <div className="w-32 sm:w-40 pb-4 mx-auto sm:mx-0" style={{ height: '100px' }}>
              <Link to="/" className="block h-full">
                <img
                  src={LOGO_SRC}
                  alt="Ancient Engineering logo"
                  className="h-full w-auto object-contain mx-auto sm:mx-0"
                  style={{ transform: 'scale(2.5)', transformOrigin: 'center center' }}
                />
              </Link>
            </div>
            
            {/* Social Media Icons */}
            <div className="mt-12 w-full">
              <div className="flex items-center gap-3 justify-start -ml-[27px] sm:-ml-[35px]">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="flex h-10 w-10 items-center justify-center rounded-full bg-white/10 text-white transition-colors hover:bg-white/20"
                aria-label="Facebook"
              >
                <FacebookIcon fontSize="small" />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="flex h-10 w-10 items-center justify-center rounded-full bg-white/10 text-white transition-colors hover:bg-white/20"
                aria-label="Twitter"
              >
                <TwitterIcon fontSize="small" />
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="flex h-10 w-10 items-center justify-center rounded-full bg-white/10 text-white transition-colors hover:bg-white/20"
                aria-label="LinkedIn"
              >
                <LinkedInIcon fontSize="small" />
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="flex h-10 w-10 items-center justify-center rounded-full bg-white/10 text-white transition-colors hover:bg-white/20"
                aria-label="Instagram"
              >
                <InstagramIcon fontSize="small" />
              </a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="text-center sm:text-left">
            <h4 className="text-lg font-semibold">Quick Links</h4>
            <ul className="mt-4 space-y-2 text-sm">
              <li>
                <Link to="/" className="text-white/80 transition-colors hover:text-white">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-white/80 transition-colors hover:text-white">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-white/80 transition-colors hover:text-white">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-white/80 transition-colors hover:text-white">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div className="text-center sm:text-left">
            <h4 className="text-lg font-semibold">Services</h4>
            <ul className="mt-4 space-y-2 text-sm">
              <li>
                <Link to="/services" className="text-white/80 transition-colors hover:text-white">
                  Industrial Automation
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-white/80 transition-colors hover:text-white">
                  Solar PV Solutions
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-white/80 transition-colors hover:text-white">
                  Fabrication & Mechanical
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-white/80 transition-colors hover:text-white">
                  ICT & Security
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="text-center sm:text-left">
            <h4 className="text-lg font-semibold">Contact</h4>
            <ul className="mt-4 space-y-2 text-sm text-white/80">
              <li>161 Gleneagles RD Harare, Zimbabwe</li>
              <li>
                <a href="mailto:Info@ancientengineering.co.zw" className="transition-colors hover:text-white">
                  Info@ancientengineering.co.zw
                </a>
              </li>
              <li>
                <a href="tel:+263772960955" className="transition-colors hover:text-white">
                  +263 77 296 0955
                </a>
              </li>
              <li>
                <a href="tel:+263772813788" className="transition-colors hover:text-white">
                  +263 77 281 3788
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 border-t border-white/20 pt-8 flex flex-col sm:flex-row justify-center sm:justify-between items-center gap-4 text-sm text-white/80 text-center sm:text-left">
          <p>&copy; {new Date().getFullYear()} Ancient Engineering. All rights reserved.</p>
          <p>
            Designed and developed by{' '}
            <a
              href="https://spemedia.co.zw"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white transition-colors hover:text-white/80"
            >
              spemedia.co.zw
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
